/* Craft picks. Personal when we know them, generic when we do not, rotating
 * either way; every exit silent. The reasoning is in the doc block of
 * snippets/craft-picks.liquid — this file is at the 16,384-char push ceiling. */
(function () {
  'use strict';

  var MIN_SCORE = 1.8;      // one glance is not a preference
  var LIMIT_PER_GROUP = 10;
  var RAIL_TOTAL = 16;
  var DISMISS_KEY = 'sjt_craft_dismissed_v1';
  var CHOSEN_KEY = 'sjt_craft_chosen_v1';
  var ROTATE_KEY = 'sjt_craft_rotate_v1';
  var SKIP_PATHS = ['/cart', '/checkout', '/account', '/challenge', '/password'];
  var TIMEOUT_MS = 7000;
  var NEW_LABEL = 'New in';
  var NEW_DAYS = 90;        // after which "new" is no longer true

  function data(id) {
    try {
      var n = document.getElementById(id);
      return n ? JSON.parse(n.textContent || '{}') : null;
    } catch (e) { return null; }
  }

  /* Read-only now — see swapTo(). An old dismissal is still honoured. */
  function dismissed() {
    try { return JSON.parse(window.localStorage.getItem(DISMISS_KEY) || '[]') || []; }
    catch (e) { return []; }
  }

  /** Asked for by hand. Outranks behaviour. */
  function chosenCraft() {
    try { return window.localStorage.getItem(CHOSEN_KEY) || ''; }
    catch (e) { return ''; }
  }

  function chooseCraft(craft) {
    try { window.localStorage.setItem(CHOSEN_KEY, craft); }
    catch (e) { /* a preference we cannot store is still honoured this page */ }
  }

  /* The cursor craft-rotate.js advances: both rotations move together. */
  function rotation() {
    try {
      var n = parseInt(window.localStorage.getItem(ROTATE_KEY) || '0', 10);
      return isFinite(n) && n >= 0 ? n : 0;
    } catch (e) { return 0; }
  }

  function skipPage() {
    var p = (window.location.pathname || '').toLowerCase();
    for (var i = 0; i < SKIP_PATHS.length; i++) if (p.indexOf(SKIP_PATHS[i]) === 0) return true;
    return false;
  }

  /** After "You may also like"; above the footer when there is none. */
  function placement() {
    var ymal = document.querySelector('.related-products');
    if (ymal) {
      var host = ymal.closest('.color-background-1, .gradient, section') || ymal;
      return { node: host, where: 'after' };
    }
    var foot = document.querySelector('footer') || document.querySelector('.footer');
    return foot ? { node: foot, where: 'before' } : null;
  }

  function anchorCraft(picks, pageCrafts) {
    var onPage = {}, i;
    for (i = 0; i < (pageCrafts || []).length; i++) onPage[String(pageCrafts[i]).trim()] = true;

    // Asked-for outranks history, the MIN_SCORE gate and any old dismissal.
    var asked = chosenCraft();
    if (asked && !onPage[asked] && picks[asked] && picks[asked].count > 0) {
      return { craft: asked, entry: picks[asked], asked: true };
    }

    var off = dismissed();
    for (i = 0; i < off.length; i++) onPage[off[i]] = true;

    // Pre-rotated by craft-rotate.js: Nth-best leads on the Nth page view.
    var memory = window.SujatraCraftMemory.top();
    var total = 0;
    for (i = 0; i < memory.length; i++) total += memory[i].score;
    if (total < MIN_SCORE) return null;

    for (i = 0; i < memory.length; i++) {
      var craft = memory[i].craft;
      if (onPage[craft]) continue;
      var entry = picks[craft];
      if (entry && entry.count > 0) return { craft: craft, entry: entry, bought: memory[i].bought };
    }
    return null;
  }

  /* For someone we do not know yet, where there used to be nothing. */
  function genericAnchor(generic) {
    if (!generic || !generic.length) return null;
    var pick = generic[rotation() % generic.length];
    return { craft: null, entry: pick, generic: true };
  }

  /** Measured, live, not dismissed, not the anchor. */
  function partnerCraft(affinity, picks, anchor) {
    if (!affinity || !affinity.crafts || !anchor.craft) return null;
    var row = affinity.crafts[anchor.craft];
    if (!row || !row.partners) return null;
    var off = dismissed();
    for (var i = 0; i < row.partners.length; i++) {
      var name = row.partners[i];
      if (name === anchor.craft) continue;
      if (off.indexOf(name) !== -1) continue;
      var entry = picks[name];
      if (entry && entry.count > 0) return { craft: name, entry: entry };
    }
    return null;
  }

  function viewedCount(craft) {
    try {
      var rec = window.SujatraCraftMemory.raw();
      var v = rec && rec.views && rec.views[craft];
      return v && v.n ? Math.max(1, Math.round(v.n)) : 0;
    } catch (e) { return 0; }
  }

  /** Rendered by sections/craft-picks.liquid. */
  function collectionUrl(handle, sort) {
    return '/collections/' + encodeURIComponent(handle) + '?section_id=craft-picks'
      + (sort ? '&sort_by=' + sort : '');
  }

  /* Deduped by LABEL: two crafts can share one label. */
  function otherCrafts(picks, current) {
    var out = [], seen = {}, craft, e;
    for (craft in picks) {
      if (!Object.prototype.hasOwnProperty.call(picks, craft)) continue;
      if (craft === current) continue;
      e = picks[craft];
      if (!e || !e.count) continue;
      if (seen[e.label]) continue;
      seen[e.label] = true;
      out.push({ craft: craft, entry: e });
    }
    out.sort(function (a, b) { return a.entry.label < b.entry.label ? -1 : 1; });
    return out;
  }

  function fetchCards(url) {
    return window.fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim()) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.bs-rail__item'));
      })
      .catch(function () { return []; });
  }

  /** Drop duplicates across groups and the garment already on screen. */
  function dedupe(items, seen) {
    var here = window.location.pathname.replace(/\/$/, '');
    var out = [];
    for (var i = 0; i < items.length && out.length < LIMIT_PER_GROUP; i++) {
      var a = items[i].querySelector('a[href*="/products/"]');
      var href = a ? a.getAttribute('href').split('?')[0].replace(/\/$/, '') : null;
      if (!href || seen[href]) continue;
      if (here.indexOf(href) !== -1) continue;
      seen[href] = true;
      out.push(items[i]);
    }
    return out;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* Round-robin: a group of ten must not swallow the rail. Group ORDER carries
     the loyal / not-loyal decision. */
  function mergeRail(groups, total) {
    var out = [], i, g, taken = 0, round = 0;
    while (out.length < total) {
      taken = 0;
      for (i = 0; i < groups.length; i++) {
        g = groups[i].items;
        if (round < g.length && out.length < total) {
          badge(g[round], groups[i].badge);
          tidyPrice(g[round]);
          out.push(g[round]);
          taken++;
        }
      }
      if (!taken) break;
      round++;
    }
    return out;
  }

  /* "MRP. 1,999.00 INR" -> "MRP 1,999". */
  function tidyPrice(item) {
    var nodes = item.querySelectorAll('.price-item, .price__regular .price-item--regular, .cc-price');
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i].textContent;
      if (t.indexOf('MRP') === -1 && t.indexOf('.00') === -1) continue;
      nodes[i].textContent = t.replace('MRP.', 'MRP').replace('.00', '').replace(/\s*INR\s*$/, '').trim();
    }
  }

  /* Newest in a quiet craft can be years old. No date, no claim. */
  function isRecent(item) {
    var t = parseInt(item.getAttribute('data-created') || '', 10);
    if (!t) return false;
    return (Date.now() / 1000 - t) < NEW_DAYS * 86400;
  }

  /** Why this card is here, over its photograph. */
  function badge(item, label) {
    if (!label) return;
    if (label === NEW_LABEL && !isRecent(item)) return;
    var media = item.querySelector('.card__media') || item;
    if (media.querySelector('.craft-picks__why')) return;
    media.appendChild(el('span', 'craft-picks__why', label));
  }

  /* Hand-chosen craft, and the generic rail. No "try something different". */
  function cardsFor(entry) {
    return Promise.all([
      fetchCards(collectionUrl(entry.handle, null)),
      fetchCards(collectionUrl(entry.handle, 'created-descending'))
    ]).then(function (res) {
      var seen = {};
      return mergeRail([
        { badge: 'Bestseller', items: dedupe(res[0], seen) },
        { badge: NEW_LABEL, items: dedupe(res[1], seen) }
      ], RAIL_TOTAL);
    }).catch(function () { return []; });
  }

  function track(items) {
    var t = el('div', 'craft-picks__track');
    t.setAttribute('role', 'list');
    for (var i = 0; i < items.length; i++) t.appendChild(items[i]);
    return t;
  }

  function render(anchor, partner, groups, size, picks) {
    var any = false, i;
    for (i = 0; i < groups.length; i++) if (groups[i].items.length) any = true;
    if (!any) return;
    if (document.getElementById('craft-picks')) return;
    var spot = placement();
    if (!spot) return;

    var wrap = el('section', 'craft-picks');
    wrap.id = 'craft-picks';
    wrap.setAttribute('aria-label', anchor.generic ? 'From the shop' : 'Picked for you');

    var head = el('div', 'craft-picks__head');
    // Only what the record supports: "bought" needs a purchase on record, and a
    // generic rail claims nothing, having no history behind it.
    var eyebrow = el('p', 'craft-picks__eyebrow',
      anchor.generic ? (anchor.entry.eyebrow || 'From the shop')
        : anchor.asked ? 'You asked for' : 'Picked for you');
    head.appendChild(eyebrow);

    var heading = el('h2', 'craft-picks__heading',
      anchor.generic || anchor.asked
        ? anchor.entry.label
        : anchor.bought
          ? 'You have bought ' + anchor.entry.label + ' before'
          : 'You keep coming back to ' + anchor.entry.label);
    head.appendChild(heading);

    var bits = [];
    if (!anchor.asked && !anchor.generic) {
      var n = viewedCount(anchor.craft);
      if (n >= 2) bits.push('You have looked at ' + n + ' ' + anchor.entry.label + ' pieces');
      if (size) bits.push('you usually pick ' + size);
    }
    var meta = bits.length ? el('p', 'craft-picks__meta', bits.join(' · ')) : null;
    if (meta) head.appendChild(meta);

    // "Not Madhubani" is about Madhubani, not about being shown work they like,
    // so this swaps rather than switches off and records the craft they WANT;
    // reading it as a dismissal retired three crafts and killed the rail. A
    // generic rail has nothing personal to opt out of.
    var current = { craft: anchor.craft, entry: anchor.entry };
    var off = null, chooser = null, chips = null;

    if (!anchor.generic) {
      off = el('button', 'craft-picks__dismiss', 'Not ' + anchor.entry.label + '?');
      off.type = 'button';
      off.setAttribute('aria-expanded', 'false');
      head.appendChild(off);
    }
    wrap.appendChild(head);

    if (!anchor.generic) {
      chooser = el('div', 'craft-picks__swap');
      chooser.hidden = true;
      chooser.appendChild(el('p', 'craft-picks__swaplead', 'Show me instead'));
      chips = el('div', 'craft-picks__chips');
      chooser.appendChild(chips);
      wrap.appendChild(chooser);
    }

    function openChooser(open) {
      chooser.hidden = !open;
      off.setAttribute('aria-expanded', open ? 'true' : 'false');
      off.textContent = open ? 'Never mind' : 'Not ' + current.entry.label + '?';
    }

    /** Swap the rail to a hand-chosen craft. */
    function swapTo(choice) {
      chooseCraft(choice.craft);
      chooser.setAttribute('aria-busy', 'true');
      cardsFor(choice.entry).then(function (fresh) {
        chooser.removeAttribute('aria-busy');
        // Nothing back: keep what is on screen rather than emptying it.
        if (!fresh.length) return;
        var old = wrap.querySelector('.craft-picks__track');
        if (old) wrap.replaceChild(track(fresh), old);
        current = choice;
        // The evidence line was true of their history, not of this request.
        eyebrow.textContent = 'You asked for';
        heading.textContent = choice.entry.label;
        if (meta && meta.parentNode) meta.parentNode.removeChild(meta);
        meta = null;
        fillChips();
        openChooser(false);
      });
    }

    function fillChips() {
      while (chips.firstChild) chips.removeChild(chips.firstChild);
      var others = otherCrafts(picks, current.craft), j;
      for (j = 0; j < others.length; j++) {
        (function (choice) {
          var chip = el('button', 'craft-picks__chip', choice.entry.label);
          chip.type = 'button';
          chip.addEventListener('click', function () { swapTo(choice); });
          chips.appendChild(chip);
        })(others[j]);
      }
    }

    if (off) {
      off.addEventListener('click', function () { openChooser(chooser.hidden); });
      fillChips();
    }

    var cards = mergeRail(groups, RAIL_TOTAL);
    if (!cards.length) return;
    wrap.appendChild(track(cards));

    if (spot.where === 'after') spot.node.parentNode.insertBefore(wrap, spot.node.nextSibling);
    else spot.node.parentNode.insertBefore(wrap, spot.node);
  }

  function boot() {
    try {
      if (skipPage()) return;
      if (!window.SujatraCraftMemory || !window.fetch || !window.DOMParser || !window.Promise) return;

      var picksData = data('craft-picks-data');
      var memoryData = data('craft-memory-data');
      if (!picksData || !picksData.crafts) return;

      var anchor = anchorCraft(picksData.crafts, memoryData && memoryData.pageCrafts);

      // No history yet: a generic rail rather than an empty slot.
      if (!anchor) {
        var cold = genericAnchor(picksData.generic);
        if (!cold) return;
        cardsFor(cold.entry).then(function (cards) {
          if (!cards.length) return;
          render(cold, null, [{ badge: null, items: cards }], null, picksData.crafts);
        });
        return;
      }

      var affinityUrl = picksData.affinityUrl;
      var affinityReq = affinityUrl
        ? window.fetch(affinityUrl).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        : Promise.resolve(null);

      affinityReq.then(function (affinity) {
        var partner = partnerCraft(affinity, picksData.crafts, anchor);
        var row = affinity && affinity.crafts && affinity.crafts[anchor.craft];
        // Measured: does this craft actually reward more of itself?
        var loyal = row ? !!row.loyal : true;

        var reqs = [fetchCards(collectionUrl(anchor.entry.handle, null)),
                    fetchCards(collectionUrl(anchor.entry.handle, 'created-descending'))];
        reqs.push(partner ? fetchCards(collectionUrl(partner.entry.handle, null)) : Promise.resolve([]));

        var done = false;
        var timer = window.setTimeout(function () { done = true; }, TIMEOUT_MS);

        Promise.all(reqs).then(function (res) {
          window.clearTimeout(timer);
          if (done) return;

          var seen = {};
          var same = [
            { badge: 'Bestseller', items: dedupe(res[0], seen) },
            { badge: NEW_LABEL, items: dedupe(res[1], seen) },
          ];
          var diff = partner
            ? [{ badge: 'Try ' + partner.entry.label, items: dedupe(res[2], seen) }]
            : [];

          // Loyal craft: lead with more of it. Not loyal: lead with the change.
          render(anchor, partner, loyal ? same.concat(diff) : diff.concat(same),
                 window.SujatraCraftMemory.usualSize(), picksData.crafts);
        }).catch(function () { window.clearTimeout(timer); });
      });
    } catch (e) { /* a rail must never break the page */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();